import { RcThemeInput } from '@ringcentral/juno';
import { BLACK, FORM_LABEL_COLOR } from '@/shared/theme/utils/color';

type Overrides = RcThemeInput['overrides'];

export const overridesFactory = (primaryColor: string): Overrides => ({
  MuiDialog: {
    paper: {
      color: `${BLACK} !important`,
    },
  },
  MuiInput: {
    underline: {
      '&.Mui-focused:after': {
        borderBottomColor: `${primaryColor} !important`,
      },
      '&:hover:not(.Mui-disabled):before': {
        borderBottomColor: `${primaryColor} !important`,
      },
    },
  },
  MuiFormLabel: {
    root: {
      color: FORM_LABEL_COLOR,
    },
  },
  MuiInputBase: {
    root: {
      color: BLACK,
    },
  },
});
